import { Routes } from '@angular/router';
import { AuthGuard, NonInfluencerGuard } from '@app/_guards';
import { DashboardComponent } from './dashboard.component';

/**
 * First in ROOT_ROUTES, so this pathMatch:full route wins over the features served
 * from the root that also register path: ''.
 */
export const DASHBOARD_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: DashboardComponent,
    canActivate: [AuthGuard, NonInfluencerGuard],
  },
];
